// Module
var code = `<div class="editor-file-upload">
	<label>Upload new file</label>
	<form name="editor-file-upload" class="form-upload" method="POST" action="">
		<input type="file" name="file" class="input-file">
	</form>

	<div class="or-separator">OR</div>

	<label>Use file url</label>
	<input type="text" name="url" class="input-url">
</div>
`;
// Exports
export default code;